import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as enums from '../../../../../enums'
import * as asset from '../asset'

export const RESOURCE = {
  payload: {
    canBeOptional: false,
    context: core.dms.models.Attribute.Id.Context.from({
      context: asset.RESOURCE.payload.dimension.partialId,
      partialId: asset.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description: 'E.g. building or equipment',
    isOptional: false,
    name: 'Type',
    partialId: PartialId.Standard.create('type'),
    type: {
      enumId: core.dms.models.Enum.Id.from(enums.assetType.RESOURCE.payload),
      isMultiselect: false,
    },
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
